export default "/images/vendor/flag-icon-css/flags/4x3/sa.svg?d2ac71bc08a7e11cd8dfdc38bfe2434b";